(function () {
var FREE_SHIPPING_THRESHOLD = 6999;
var observer = null;
var priceObserver = null;
var injectScheduled = false;
var updateScheduled = false;
var confettiAlreadyPlayed = false;
var lastKnownTotal = null;

var CSS = [
'#hv-good-choice {',
'width: 100%;',
'background: #006039;',
'padding: 10px 24px;',
'margin: 0;',
'display: flex;',
'align-items: center;',
'justify-content: center;',
'gap: 10px;',
'box-sizing: border-box;',
'}',

'#hv-good-choice-icon {',
'flex-shrink: 0;',
'width: 23.1px;',
'height: 23.1px;',
'color: #ffffff;',
'}',

'#hv-good-choice-text {',
'font-size: 15.4px;',
'line-height: 1.25;',
'color: #ffffff;',
'font-family: inherit;',
'font-weight: 600;',
'text-align: center;',
'letter-spacing: 0;',
'}',

'#hv-shipping-progress {',
'position: relative;',
'width: 100%;',
'padding: 13px 22px 14px;',
'margin: 0 0 10px;',
'background: #ffffff;',
'border-top: 1px solid #dddddd;',
'border-bottom: 1px solid #dddddd;',
'box-shadow: 0 3px 10px rgba(17, 17, 17, 0.045);',
'box-sizing: border-box;',
'overflow: visible;',
'isolation: isolate;',
'}',

'#hv-shipping-progress::before {',
'content: "";',
'position: absolute;',
'inset: 0;',
'background: linear-gradient(180deg, rgba(201, 166, 82, 0.025) 0%, rgba(255, 255, 255, 0) 65%);',
'pointer-events: none;',
'z-index: 0;',
'}',

'#hv-shipping-progress-inner {',
'position: relative;',
'z-index: 2;',
'width: 100%;',
'max-width: 520px;',
'margin: 0 auto;',
'}',

'#hv-shipping-progress-top {',
'display: flex;',
'align-items: center;',
'justify-content: center;',
'gap: 8px;',
'margin-bottom: 9px;',
'}',

'#hv-shipping-progress-icon {',
'flex-shrink: 0;',
'width: 17px;',
'height: 17px;',
'color: #a67c21;',
'transition: transform 240ms ease, color 240ms ease;',
'}',

'#hv-shipping-progress-text {',
'font-size: 13px;',
'line-height: 1.3;',
'color: #242424;',
'font-family: inherit;',
'font-weight: 600;',
'text-align: center;',
'letter-spacing: 0.01em;',
'}',

'#hv-shipping-progress-text strong {',
'font-weight: 800;',
'color: #8a681d;',
'}',

'#hv-shipping-progress-track {',
'position: relative;',
'width: 100%;',
'height: 7px;',
'background: #eeeeee;',
'border: 1px solid #d8d8d8;',
'border-radius: 999px;',
'box-sizing: border-box;',
'overflow: hidden;',
'box-shadow: inset 0 1px 2px rgba(17, 17, 17, 0.08);',
'}',

'#hv-shipping-progress-fill {',
'position: absolute;',
'top: 0;',
'bottom: 0;',
'left: 0;',
'width: 0%;',
'border-radius: inherit;',
'background: linear-gradient(90deg, #b88c2c 0%, #e5c875 52%, #b98c2c 100%);',
'box-shadow: 0 0 11px rgba(201, 166, 82, 0.28);',
'transition: width 380ms cubic-bezier(0.22, 1, 0.36, 1);',
'}',

'#hv-shipping-progress-fill::after {',
'content: "";',
'position: absolute;',
'top: 0;',
'left: -40%;',
'width: 35%;',
'height: 100%;',
'background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.42), transparent);',
'transform: skewX(-20deg);',
'animation: hv-shipping-shimmer 2.7s infinite;',
'}',

'#hv-shipping-progress.is-complete {',
'background: #ffffff;',
'border-top-color: rgba(201, 166, 82, 0.55);',
'border-bottom-color: rgba(201, 166, 82, 0.55);',
'}',

'#hv-shipping-progress.is-complete #hv-shipping-progress-fill {',
'background: linear-gradient(90deg, #b88c2c 0%, #e5c875 52%, #b98c2c 100%);',
'box-shadow: 0 0 11px rgba(201, 166, 82, 0.28);',
'}',

'#hv-shipping-progress.is-complete #hv-shipping-progress-icon {',
'color: #a67c21;',
'transform: scale(1.08);',
'}',

'#hv-shipping-progress.is-complete #hv-shipping-progress-text strong {',
'color: #8a681d;',
'}',

'#hv-free-shipping-cart-label {',
'display: none;',
'width: 100%;',
'box-sizing: border-box;',
'font-family: inherit;',
'font-size: 12.5px;',
'line-height: 1.3;',
'font-weight: 600;',
'color: #006039;',
'margin-top: 3px;',
'text-align: right;',
'}',

'#hv-free-shipping-cart-label.is-visible {',
'display: block;',
'}',

'#hv-confetti-layer {',
'position: fixed;',
'inset: 0;',
'z-index: 2147483647;',
'overflow: hidden;',
'pointer-events: none;',
'}',

'.hv-confetti-piece {',
'position: fixed;',
'width: 6px;',
'height: 10px;',
'border-radius: 1px;',
'opacity: 0;',
'will-change: transform, opacity;',
'animation-name: hv-confetti-burst;',
'animation-timing-function: cubic-bezier(0.18, 0.72, 0.28, 1);',
'animation-fill-mode: forwards;',
'}',

'@keyframes hv-shipping-shimmer {',
'0% {',
'left: -40%;',
'}',
'60%, 100% {',
'left: 125%;',
'}',
'}',

'@keyframes hv-confetti-burst {',
'0% {',
'opacity: 0;',
'transform: translate3d(0, 0, 0) scale(0.72) rotate(0deg);',
'}',
'12% {',
'opacity: 1;',
'}',
'72% {',
'opacity: 0.95;',
'}',
'100% {',
'opacity: 0;',
'transform: translate3d(var(--hv-x), var(--hv-y), 0) scale(0.9) rotate(var(--hv-rotate));',
'}',
'}',

'@media screen and (max-width: 749px) {',

'#hv-good-choice {',
'padding: 9px 16px;',
'gap: 8px;',
'}',

'#hv-good-choice-icon {',
'width: 20.9px;',
'height: 20.9px;',
'}',

'#hv-good-choice-text {',
'font-size: 14.1px;',
'}',

'#hv-shipping-progress {',
'padding: 12px 16px 13px;',
'margin-bottom: 8px;',
'}',

'#hv-shipping-progress-top {',
'gap: 7px;',
'margin-bottom: 8px;',
'}',

'#hv-shipping-progress-icon {',
'width: 16px;',
'height: 16px;',
'}',

'#hv-shipping-progress-text {',
'font-size: 12.3px;',
'}',

'#hv-shipping-progress-track {',
'height: 6px;',
'}',

'#hv-free-shipping-cart-label {',
'font-size: 12px;',
'margin-top: 3px;',
'}',

'}',

'@media (prefers-reduced-motion: reduce) {',

'#hv-shipping-progress-fill {',
'transition: none;',
'}',

'#hv-shipping-progress-fill::after {',
'animation: none;',
'}',

'.hv-confetti-piece {',
'animation: none;',
'display: none;',
'}',

'}'
].join('');

function injectStyles() {
var oldTimerStyles = document.getElementById(
'hv-timer-styles'
);

if (oldTimerStyles) {
oldTimerStyles.remove();
}

var oldBarStyles = document.getElementById(
'hv-cart-bars-styles'
);

if (oldBarStyles) {
oldBarStyles.remove();
}

var style = document.createElement('style');

style.id = 'hv-cart-bars-styles';
style.textContent = CSS;

document.head.appendChild(style);
}

function buildGoodChoice() {
var bar = document.createElement('div');

bar.id = 'hv-good-choice';

bar.innerHTML = [
'<svg id="hv-good-choice-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">',

'<path d="M12 2.5l1.4 3.8 3.8 1.4-3.8 1.4-1.4 3.8-1.4-3.8-3.8-1.4 3.8-1.4L12 2.5z" fill="white"/>',

'<path d="M18.5 10.5l0.9 2.4 2.4 0.9-2.4 0.9-0.9 2.4-0.9-2.4-2.4-0.9 2.4-0.9 0.9-2.4z" fill="white" opacity="0.95"/>',

'<path d="M6 13.5l1.1 3 3 1.1-3 1.1L6 21.5l-1.1-2.8-3-1.1 3-1.1L6 13.5z" fill="white" opacity="0.9"/>',

'</svg>',

'<span id="hv-good-choice-text">Über 30.000+ Kunden vertrauen HAARVANA</span>'
].join('');

return bar;
}

function buildShippingProgress() {
var bar = document.createElement('div');

bar.id = 'hv-shipping-progress';
bar.setAttribute('role', 'status');
bar.setAttribute('aria-live', 'polite');

bar.innerHTML = [
'<div id="hv-shipping-progress-inner">',

'<div id="hv-shipping-progress-top">',

'<svg id="hv-shipping-progress-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">',

'<path d="M3.5 6.5H15.5V16.5H3.5V6.5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>',

'<path d="M15.5 9H18.2L21 12V16.5H15.5V9Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>',

'<path d="M7 19C8.10457 19 9 18.1046 9 17C9 15.8954 8.10457 15 7 15C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19Z" fill="currentColor"/>',

'<path d="M18 19C19.1046 19 20 18.1046 20 17C20 15.8954 19.1046 15 18 15C16.8954 15 16 15.8954 16 17C16 18.1046 16.8954 19 18 19Z" fill="currentColor"/>',

'</svg>',

'<span id="hv-shipping-progress-text">Versandvorteil wird berechnet …</span>',

'</div>',

'<div id="hv-shipping-progress-track" aria-hidden="true">',

'<div id="hv-shipping-progress-fill"></div>',

'</div>',

'</div>'
].join('');

return bar;
}

function normalizeMoneyString(value) {
if (!value) {
return null;
}

var normalized = String(value)
.replace(/\u00A0/g, ' ')
.replace(/\s/g, '')
.replace(/[^0-9,.-]/g, '');

if (!normalized) {
return null;
}

var lastComma = normalized.lastIndexOf(',');
var lastDot = normalized.lastIndexOf('.');
var decimalPosition = Math.max(lastComma, lastDot);

if (decimalPosition > -1) {
var integerPart = normalized
.slice(0, decimalPosition)
.replace(/[.,]/g, '');

var decimalPart = normalized
.slice(decimalPosition + 1)
.replace(/[.,]/g, '');

decimalPart = (decimalPart + '00').slice(0, 2);

var decimalValue =
parseInt(integerPart || '0', 10) * 100 +
parseInt(decimalPart || '0', 10);

return isNaN(decimalValue)
? null
: decimalValue;
}

var integerValue = parseInt(
normalized.replace(/[.,]/g, ''),
10
);

return isNaN(integerValue)
? null
: integerValue * 100;
}

function isVisible(element) {
if (!element) {
return false;
}

var style = window.getComputedStyle(element);
var rect = element.getBoundingClientRect();

return (
style.display !== 'none' &&
style.visibility !== 'hidden' &&
Number(style.opacity || 1) !== 0 &&
rect.width > 0 &&
rect.height > 0
);
}

function getVisibleCartTotalElement() {
var selectors = [
'[data-testid="cart-total-value"]',
'[data-cart-subtotal]',
'[ref="cartTotal"]',
'.cart-totals__total-value',
'.cart__total-value',
'.totals__total-value',
'.kaching-bundles__cart-total',
'[class*="kaching"][class*="total"]',
'[data-kaching-cart-total]'
];

var elements = Array.prototype.slice.call(
document.querySelectorAll(selectors.join(','))
);

for (var i = 0; i < elements.length; i++) {
var element = elements[i];

if (
element &&
isVisible(element) &&
!element.closest('#hv-shipping-progress') &&
!element.closest('#hv-free-shipping-cart-label')
) {
return element;
}
}

return null;
}

function getCurrentCartTotal() {
var totalElement = getVisibleCartTotalElement();

if (totalElement) {
var value =
totalElement.getAttribute('value') ||
totalElement.getAttribute('data-price') ||
totalElement.getAttribute('data-total') ||
totalElement.textContent;

var parsedValue = normalizeMoneyString(value);

if (parsedValue !== null) {
return parsedValue;
}
}

var cartPriceData = document.getElementById(
'hv-cart-price-data'
);

if (cartPriceData) {
try {
var parsedData = JSON.parse(
cartPriceData.textContent
);

if (
parsedData &&
typeof parsedData.cartTotal !== 'undefined'
) {
return Number(parsedData.cartTotal);
}
} catch (error) {
/* Ungültige Preisdaten werden ignoriert. */
}
}

return null;
}

function formatMoney(cents) {
var numericCents = Math.max(
0,
Math.round(Number(cents) || 0)
);

if (
window.Shopify &&
typeof window.Shopify.formatMoney === 'function'
) {
try {
return window.Shopify.formatMoney(
numericCents,
'{{amount_with_comma_separator}} €'
);
} catch (error) {
/* Fallback wird darunter verwendet. */
}
}

return (numericCents / 100).toLocaleString(
'de-DE',
{
minimumFractionDigits: 2,
maximumFractionDigits: 2
}
) + ' €';
}

function getShippingText(totalCents) {
if (totalCents >= FREE_SHIPPING_THRESHOLD) {
return '<strong>Kostenloser Versand freigeschaltet</strong>';
}

var missingAmount =
FREE_SHIPPING_THRESHOLD - totalCents;

return (
'Nur noch <strong>' +
formatMoney(missingAmount) +
'</strong> bis zum kostenlosen Versand'
);
}

function injectFreeShippingLabel() {
var totalElement = getVisibleCartTotalElement();

if (!totalElement) {
return null;
}

var existingLabel = document.getElementById(
'hv-free-shipping-cart-label'
);

if (existingLabel) {
return existingLabel;
}

var label = document.createElement('div');

label.id = 'hv-free-shipping-cart-label';
label.textContent = '+ kostenloser Versand';

var totalContainer =
totalElement.parentElement;

if (totalContainer) {
totalContainer.appendChild(label);
}

return label;
}

function updateFreeShippingLabel(totalCents) {
var label = document.getElementById(
'hv-free-shipping-cart-label'
);

if (!label) {
label = injectFreeShippingLabel();
}

if (!label) {
return;
}

if (
totalCents !== null &&
!isNaN(totalCents) &&
totalCents >= FREE_SHIPPING_THRESHOLD
) {
label.classList.add('is-visible');
label.textContent = '+ kostenloser Versand';
} else {
label.classList.remove('is-visible');
}
}

function updateShippingProgress() {
updateScheduled = false;

var bar = document.getElementById(
'hv-shipping-progress'
);

var text = document.getElementById(
'hv-shipping-progress-text'
);

var fill = document.getElementById(
'hv-shipping-progress-fill'
);

if (!bar || !text || !fill) {
return;
}

var currentTotal = getCurrentCartTotal();

updateFreeShippingLabel(currentTotal);

if (currentTotal === null || isNaN(currentTotal)) {
text.textContent =
'Versandvorteil wird berechnet …';

fill.style.width = '0%';
bar.classList.remove('is-complete');

return;
}

var progress = Math.min(
100,
Math.max(
0,
currentTotal /
FREE_SHIPPING_THRESHOLD *
100
)
);

text.innerHTML = getShippingText(
currentTotal
);

fill.style.width = progress + '%';

if (
currentTotal >= FREE_SHIPPING_THRESHOLD
) {
bar.classList.add('is-complete');

if (
!confettiAlreadyPlayed &&
(
lastKnownTotal === null ||
lastKnownTotal <
FREE_SHIPPING_THRESHOLD
)
) {
confettiAlreadyPlayed = true;
launchConfetti();
}
} else {
bar.classList.remove('is-complete');
confettiAlreadyPlayed = false;
}

lastKnownTotal = currentTotal;
}

function scheduleShippingUpdate() {
if (updateScheduled) {
return;
}

updateScheduled = true;

requestAnimationFrame(
updateShippingProgress
);
}

function observeVisiblePrice() {
if (priceObserver) {
priceObserver.disconnect();
priceObserver = null;
}

var totalElement =
getVisibleCartTotalElement();

if (!totalElement) {
scheduleShippingUpdate();
return;
}

priceObserver = new MutationObserver(
function () {
scheduleShippingUpdate();
}
);

priceObserver.observe(totalElement, {
childList: true,
subtree: true,
characterData: true,
attributes: true,
attributeFilter: [
'value',
'data-price',
'data-total'
]
});

injectFreeShippingLabel();
scheduleShippingUpdate();
}

function launchConfetti() {
if (
window.matchMedia &&
window.matchMedia(
'(prefers-reduced-motion: reduce)'
).matches
) {
return;
}

var bar = document.getElementById(
'hv-shipping-progress'
);

if (!bar) {
return;
}

var existingLayer =
document.getElementById(
'hv-confetti-layer'
);

if (existingLayer) {
existingLayer.remove();
}

var layer = document.createElement('div');

layer.id = 'hv-confetti-layer';

var colors = [
'#006039',
'#17885c',
'#b88c2c',
'#e5c875',
'#242424'
];

var rect = bar.getBoundingClientRect();

var amount = window.innerWidth < 750
? 18
: 26;

for (var i = 0; i < amount; i++) {
var piece =
document.createElement('span');

piece.className =
'hv-confetti-piece';

var startX =
rect.left +
rect.width * (0.25 + Math.random() * 0.5);

var startY =
rect.top +
rect.height * (0.35 + Math.random() * 0.3);

piece.style.left = startX + 'px';
piece.style.top = startY + 'px';

piece.style.backgroundColor =
colors[
Math.floor(
Math.random() * colors.length
)
];

piece.style.width =
4 + Math.random() * 3 + 'px';

piece.style.height =
7 + Math.random() * 5 + 'px';

if (Math.random() > 0.72) {
piece.style.borderRadius = '50%';
}

piece.style.animationDuration =
0.95 + Math.random() * 0.55 + 's';

piece.style.animationDelay =
Math.random() * 0.12 + 's';

piece.style.setProperty(
'--hv-x',
-125 + Math.random() * 250 + 'px'
);

piece.style.setProperty(
'--hv-y',
-85 + Math.random() * 165 + 'px'
);

piece.style.setProperty(
'--hv-rotate',
220 + Math.random() * 520 + 'deg'
);

layer.appendChild(piece);
}

document.body.appendChild(layer);

window.setTimeout(function () {
if (layer && layer.parentNode) {
layer.remove();
}
}, 1900);
}

function injectBars() {
var header = document.getElementById(
'cart-drawer-header'
);

if (!header) {
return;
}

if (
!document.querySelector(
'cart-items-component .cart-form'
)
) {
return;
}

injectStyles();

var oldTimer = document.getElementById(
'hv-timer-wrap'
);

if (oldTimer) {
oldTimer.remove();
}

var oldGoodChoice =
document.getElementById(
'hv-good-choice'
);

if (oldGoodChoice) {
oldGoodChoice.remove();
}

var oldGuarantee =
document.getElementById(
'hv-guarantee-bar'
);

if (oldGuarantee) {
oldGuarantee.remove();
}

var oldShippingProgress =
document.getElementById(
'hv-shipping-progress'
);

if (oldShippingProgress) {
oldShippingProgress.remove();
}

var oldFreeShippingLabel =
document.getElementById(
'hv-free-shipping-cart-label'
);

if (oldFreeShippingLabel) {
oldFreeShippingLabel.remove();
}

var goodChoice =
buildGoodChoice();

var shippingProgress =
buildShippingProgress();

header.insertAdjacentElement(
'afterend',
shippingProgress
);

shippingProgress.insertAdjacentElement(
'beforebegin',
goodChoice
);

injectFreeShippingLabel();
observeVisiblePrice();
scheduleShippingUpdate();

window.setTimeout(
scheduleShippingUpdate,
40
);

window.setTimeout(
scheduleShippingUpdate,
120
);

window.setTimeout(function () {
injectFreeShippingLabel();
observeVisiblePrice();
scheduleShippingUpdate();
}, 300);
}

function scheduleInjectBars() {
if (injectScheduled) {
return;
}

injectScheduled = true;

requestAnimationFrame(function () {
injectScheduled = false;
injectBars();
});
}

function startObserver() {
if (observer || !document.body) {
return;
}

observer = new MutationObserver(
function (mutations) {
var needsInjection = false;
var needsPriceUpdate = false;

for (
var i = 0;
i < mutations.length;
i++
) {
var mutation = mutations[i];

if (
!document.getElementById(
'hv-good-choice'
) ||
!document.getElementById(
'hv-shipping-progress'
)
) {
needsInjection = true;
break;
}

var target =
mutation.target &&
mutation.target.nodeType === 1
? mutation.target
: mutation.target.parentElement;

if (
target &&
target.closest &&
target.closest(
'#hv-shipping-progress, #hv-good-choice, #hv-confetti-layer, #hv-free-shipping-cart-label'
)
) {
continue;
}

needsPriceUpdate = true;
}

if (needsInjection) {
scheduleInjectBars();
return;
}

if (needsPriceUpdate) {
injectFreeShippingLabel();
scheduleShippingUpdate();
}
}
);

observer.observe(document.body, {
childList: true,
subtree: true,
characterData: true
});
}

function addCartUpdateListeners() {
var events = [
'input',
'change',
'click',
'cart:updated',
'cart:update',
'cart:refresh',
'kaching:updated',
'kaching:bundle:changed'
];

events.forEach(function (eventName) {
document.addEventListener(
eventName,
function () {
scheduleShippingUpdate();

window.setTimeout(
scheduleShippingUpdate,
40
);

window.setTimeout(
scheduleShippingUpdate,
120
);

window.setTimeout(function () {
injectFreeShippingLabel();
observeVisiblePrice();
scheduleShippingUpdate();
}, 300);
},
true
);
});
}

function init() {
injectBars();
startObserver();
addCartUpdateListeners();
}

if (
document.readyState !== 'loading'
) {
init();
} else {
document.addEventListener(
'DOMContentLoaded',
init,
{
once: true
}
);
}
})();